export const getCustomerField = (customer, field) => {
	return customer?.[field] || customer?.profile?.[field]
}

const isTouched = (customer, field) => {
	if (!customer.profile) return false

	return customer.profile[field] && customer.profile[field] !== customer[field]
}

const getCustomerInfo = customer => {
	if (!customer) return false

	const { profile } = customer

	if (!profile) return customer

	return {
		...customer,
		firstName: getCustomerField(customer, 'firstName'),
		lastName: getCustomerField(customer, 'lastName'),
		phoneNumber: getCustomerField(customer, 'phoneNumber'),
		isModified:
			isTouched(customer, 'firstName') || isTouched(customer, 'lastName') || isTouched(customer, 'phoneNumber')
	}
}

export default getCustomerInfo
